import React from 'react';
import SamuraiGame from '../SamuraiGame';

const SevenYardDraw = () => {
    return <SamuraiGame initialDrillIndex={1} />;
};

export default SevenYardDraw;
